import axios from './axios'

export const getAllPackage = async () => {
    try {
        return await axios.get(`/romons.package/api/packages`)
    } catch (error) {
        throw error
    }
}

export const getPackage = async (gamecode) => {
    try {
        return await axios.get(`/romons.package/api/packages/${gamecode}`)
    } catch (error) {
        throw error
    }
}

export const getPackageTier = async (gamecode, tier) => {
    try {
        return await axios.get(`/romons.package/api/packages/${gamecode}/${tier}`)
    } catch (error) {
        throw error
    }
}

export const savePackage = async (req) => {
    try {
        return await axios.post(`/romons.package/api/packages/save`, req)
    } catch (error) {
        throw error
    }
}

export const savePrice = async (req) => {
    try {
        return await axios.post(`/romons.package/api/packages/saveprice`, req)
    } catch (error) {
        throw error
    }
}